/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Maximum quantity a shopper may purchase of a single line item.
 *
 * Parity with the legacy Ashley storefront: the 15-unit ceiling is a
 * presentation-layer constraint only — there is no `maxOrderQuantity`, site
 * preference, or catalog rule for it in the SFCC data model (the legacy
 * `productQuantity` preference is [9999, 99999]). It is therefore intentionally
 * hardcoded here as the single source of truth for the cart stepper, the PDP
 * add-to-cart quantity selector, and the server-side action guards, so the
 * three never drift.
 *
 * The effective selectable maximum is always `min(MAX_LINE_ITEM_QUANTITY, ATS)`
 * — i.e. the lesser of this ceiling and the product's available-to-sell stock —
 * which mirrors legacy ATP behavior (it blocks, rather than silently trims, an
 * over-stock order).
 */
export const MAX_LINE_ITEM_QUANTITY = 15;
